
<div class="flex-box" style="  display:flex;justify-content:space-between;">
    <p style="font-size: 20px">Gestiune / Inventar / Produse</p>


</div>
<p-divider></p-divider>
<div class="flex-box" style="display: flex; justify-content: space-between;">
    <app-stock-management> </app-stock-management>
    <p-button [label]="'Adauga inventar'" icon="pi pi-plus" iconPos="right"
              routerLink="/stock-management/inventory/add-edit"></p-button>
</div>
<p-divider></p-divider>

<div class="grid">
    <div class="col-12">
        <div class="card">
            <app-stt-table #table
                           [endpoint]="tableEndpoint"
                           [actionTemplate]="tableActionComponent"
                           [query]="tableQuery">
            </app-stt-table>
        </div>
    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" appendTo="body" closeOnEscape="true" dismissableMask="true" key="deleteInventory" ></p-confirmDialog>
